/*
 * @Description:
 * @Date: 2025-06-13 10:13:28
 */
import { translator } from '@/utils';

export const notInvoicedListTranslator = resp => {
  resp.data.list = resp.data.list.map(item => {
    return {
      ...item,
      _id: `${item.openOrderId}_${item.userDefinedOrderId}`,
      _selections: []
    };
  });
  return resp;
};
export const contentOfMakeOutAnInvoiceTranslator = resp => {
  resp.data.list = resp.data.list.map(item => {
    return {
      ...item,
      _items: []
    };
  });
  return resp;
};
export const listSelectEnterpriseTranslator = resp => {
  resp.data = resp.data.map(item => {
    return {
      ...item,
      industryId: +item.industryId
    };
  });
  return resp;
};
/**
 * @description: 添加自定义字段，用于区分选择器所选择的数据是企业还是个体
 */
export const listSupplierTranslator = resp => {
  resp.data = resp.data.map(item => {
    return {
      ...item,
      _fId: `${item.id}_${item.type}`
    };
  });
  return resp;
};
/**
 * @description: 根据自定义字段映射提交的参数
 */
export const queryInvoiceListParamsTranslator = params => {
  if (params._fId) {
    const KEY = {
      1: 'supplierId',
      2: 'individualId'
    };
    const [id, type] = params._fId.split('_');
    params[KEY[type]] = id;
  }
  return params;
};

/**
 * queryInvoiceOrder 响应 translator：代办供应商(7)合并 pager7
 * 后端在 type === 7 时返回与 pager 平级的 pager7 对象，存在则覆盖到 pager，
 * 再交由现有 pagerTranslator 统一处理（不改 pagerTranslator）。
 */
export const mergePager7Translator = (resp: any) => {
  if (resp.data?.pager7) {
    resp.data.pager = resp.data.pager7;
  }
  if (resp.data?.pager10) {
    resp.data.pager = resp.data.pager10;
  }
  return resp;
};

/**
 * recognition 响应 translator：发票识别日期归一化
 * 注意：金额 amountInFiguers 为 OCR 识别的「元」字符串（非分），无需单位转换，
 *       由调用组件解析为数值（recognition 仅新流程使用，不影响老流程）。
 */
export const recognitionResponseTranslator = resp => {
  if (resp.data?.invoiceDate) {
    resp.data.invoiceDate = resp.data.invoiceDate.replace(/年|月/g, '-');
    resp.data.invoiceDate = resp.data.invoiceDate.replace(/日/g, '');
  }
  return resp;
};

/**
 * 蓝红票列表结构 分→元（invoiceDetail 响应复用）
 * 后端 invoiceAmount / redAmount 为分，前端展示/编辑用元；
 * 单位转换统一走 translator.fen2yuan（禁止 /100）。
 */
const blueRedListFen2Yuan = (list: any[]) =>
  list.map(item => ({
    ...item,
    redAmount:
      item.redAmount != null
        ? translator.fen2yuan(Math.abs(item.redAmount))
        : item.redAmount,
    blueInvoice: item.blueInvoice
      ? {
          ...item.blueInvoice,
          invoiceAmount:
            item.blueInvoice.invoiceAmount != null
              ? translator.fen2yuan(item.blueInvoice.invoiceAmount)
              : item.blueInvoice.invoiceAmount
        }
      : item.blueInvoice,
    redInvoiceList: (item.redInvoiceList || []).map((red: any) => ({
      ...red,
      invoiceAmount:
        red.invoiceAmount != null
          ? translator.fen2yuan(Math.abs(red.invoiceAmount))
          : red.invoiceAmount
    }))
  }));

/**
 * 蓝红票列表结构 元→分（saveInvoice 请求复用）
 * 前端编辑后为元，提交后端需分；单位转换统一走 translator.yuan2fen（禁止 *100）。
 */
const blueRedListYuan2Fen = (list: any[]) =>
  list.map(item => ({
    ...item,
    redAmount:
      item.redAmount != null
        ? translator.yuan2fen(item.redAmount)
        : item.redAmount,
    blueInvoice: item.blueInvoice
      ? {
          ...item.blueInvoice,
          invoiceAmount:
            item.blueInvoice.invoiceAmount != null
              ? translator.yuan2fen(item.blueInvoice.invoiceAmount)
              : item.blueInvoice.invoiceAmount
        }
      : item.blueInvoice,
    redInvoiceList: (item.redInvoiceList || []).map((red: any) => ({
      ...red,
      invoiceAmount:
        red.invoiceAmount != null
          ? -translator.yuan2fen(red.invoiceAmount)
          : red.invoiceAmount
    }))
  }));

/**
 * invoiceDetail 响应 translator：blueRedInvoiceList 金额 分→元（票税 v2）
 * 仅新流程（7/10/平台）返回 blueRedInvoiceList，旧流程返回 detailListBlue/Red 不受影响
 */
export const invoiceDetailResponseTranslator = (resp: any) => {
  if (resp.data?.blueRedInvoiceList) {
    resp.data.blueRedInvoiceList = blueRedListFen2Yuan(
      resp.data.blueRedInvoiceList
    );
  }
  // 总票面金额分→元，与 blueRedInvoiceList 单位保持一致
  if (resp.data?.info?.sumAmount != null) {
    resp.data.info.sumAmount = translator.fen2yuan(resp.data.info.sumAmount);
  }
  // 可红冲总金额分→元
  if (resp.data?.info?.maximumCreditableAmount != null) {
    resp.data.info.maximumCreditableAmount = translator.fen2yuan(
      resp.data.info.maximumCreditableAmount
    );
  }
  if (resp.data?.info?.redAmount != null) {
    resp.data.info.redAmount = translator.fen2yuan(resp.data.info.redAmount);
  }
  return resp;
};

/**
 * saveInvoice 请求 translator：blueRedInvoiceList 金额 元→分（票税 v2）
 * 旧流程（imgList/fileList）无 blueRedInvoiceList，原样返回，金额转换仍在旧组件内（B3 保留）
 */
export const saveInvoiceRequestTranslator = (params: any) => {
  if (params?.blueRedInvoiceList) {
    return {
      ...params,
      blueRedInvoiceList: blueRedListYuan2Fen(params.blueRedInvoiceList)
    };
  }
  return params;
};

/**
 * redInvoice 请求 translator：冲红金额 元→分（票税 v2）
 * redAmount 与 redItems[].redAmount 统一转分
 */
export const redInvoiceRequestTranslator = (params: any) => {
  const next = { ...params };
  if (next.redAmount != null) {
    next.redAmount = translator.yuan2fen(next.redAmount);
  }
  if (Array.isArray(next.redItems)) {
    next.redItems = next.redItems.map((it: any) => ({
      ...it,
      redAmount:
        it.redAmount != null ? translator.yuan2fen(it.redAmount) : it.redAmount
    }));
  }
  return next;
};

/**
 * industryDetail 响应 translator：开票金额 分→元（工业线下发票）
 */
export const industryDetailResponseTranslator = (resp: any) => {
  const data = resp.data;
  if (data) {
    if (data.invoiceAmount != null) {
      data.invoiceAmount = translator.fen2yuan(data.invoiceAmount);
    }
    if (Array.isArray(data.imgList)) {
      data.imgList = data.imgList.map((item: any) => ({
        ...item,
        ...(item.invoiceAmount != null && {
          invoiceAmount: translator.fen2yuan(item.invoiceAmount)
        })
      }));
    }
  }
  return resp;
};

/**
 * industryAddInvoiceApply 请求 translator：开票金额 元→分（工业线下发票）
 */
export const industryAddInvoiceApplyRequestTranslator = (params: any) => ({
  ...params,
  ...(params.invoiceAmount != null && {
    invoiceAmount: translator.yuan2fen(params.invoiceAmount)
  }),
  ...(Array.isArray(params.imgList) && {
    imgList: params.imgList.map((item: any) => ({
      ...item,
      ...(item.invoiceAmount && {
        invoiceAmount: translator.yuan2fen(item.invoiceAmount)
      })
    }))
  })
});

/**
 * proxyTaxFile 请求 translator：代缴税金 元→分
 */
export const proxyTaxFileRequestTranslator = (params: any) => ({
  ...params,
  ...(params.proxyTaxAmount != null && {
    proxyTaxAmount: translator.yuan2fen(params.proxyTaxAmount)
  })
});
